"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

var _CampaignIcon = _interopRequireDefault(require("../CampaignIcon/CampaignIcon"));

var _ButtonIcon = _interopRequireDefault(require("../ButtonIcon/ButtonIcon"));

require("./CampaignItem.scss");

require("./CampaignItemDark.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CampaignItem = function CampaignItem(props) {
  var onPin = function onPin(e) {
    e.stopPropagation();
    props.onPin(!props.pin);
  };

  var onLoad = function onLoad(e) {
    e.stopPropagation();
    props.onLoad();
  };

  var onCancel = function onCancel(e) {
    e.stopPropagation();
    props.onCancel();
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-campitem ".concat(props.active ? 'active' : '', " ").concat(props.pin ? 'pin' : 'no-pin'),
    onClick: props.onActive
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-line ".concat(props.campaignType ? 'outbound' : 'inbound')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-dot ".concat(props.powerOn)
  }), /*#__PURE__*/_react["default"].createElement(_CampaignIcon["default"], {
    size: "sm",
    type: props.campaignType,
    frame: props.frame,
    channel: props.channel
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-data"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-campitem-name"
  }, props.label), props.showMessage && /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-message"
  }, props.message), props.showProgress && /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-progress"
  }, /*#__PURE__*/_react["default"].createElement(_ButtonIcon["default"], {
    icon: "close-circle",
    size: "small",
    onClick: onCancel
  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.Progress, {
    color: "secondary",
    striped: true,
    value: props.progress
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-pin"
  }, /*#__PURE__*/_react["default"].createElement(_ButtonIcon["default"], {
    icon: props.pin ? 'pin-in' : 'pin',
    color: props.pin ? 'primary' : 'secondary',
    onClick: onPin,
    tooltip: props.pinTooltip
  })), props.showLoadBtn && props.campaignType > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-load"
  }, /*#__PURE__*/_react["default"].createElement(_ButtonIcon["default"], {
    icon: "sc",
    onClick: onLoad,
    tooltip: props.loadTooltip
  })));
};

CampaignItem.propTypes = {
  active: _propTypes["default"].bool,
  campaignType: _propTypes["default"].oneOf([0, 1]),
  powerOn: _propTypes["default"].bool,
  pin: _propTypes["default"].bool,
  label: _propTypes["default"].string.isRequired,
  message: _propTypes["default"].string,
  showMessage: _propTypes["default"].bool,
  showProgress: _propTypes["default"].bool,
  progress: _propTypes["default"].number,
  onActive: _propTypes["default"].func.isRequired,
  onPin: _propTypes["default"].func.isRequired,
  frame: _propTypes["default"].number,
  showLoadBtn: _propTypes["default"].bool,
  onCancel: _propTypes["default"].func.isRequired,
  onLoad: _propTypes["default"].func.isRequired,
  channel: _propTypes["default"].number,
  pinTooltip: _propTypes["default"].string,
  loadTooltip: _propTypes["default"].string
};
CampaignItem.defaultProps = {
  active: false,
  campaignType: 0,
  powerOn: false,
  pin: false,
  label: '',
  onActive: function onActive() {},
  onPin: function onPin() {},
  message: '',
  showMessage: false,
  showProgress: false,
  progress: 0,
  showLoadBtn: false,
  onCancel: function onCancel() {},
  onLoad: function onLoad() {},
  channel: 0
};
var _default = CampaignItem;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/CampaignItem/CampaignItem.js
// module id = 1890
// module chunks = 0